import { render, staticRenderFns } from "./ExamAttributeTree.vue?vue&type=template&id=38303080&scoped=true&"
import script from "./ExamAttributeTree.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeTree.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeTree.vue?vue&type=style&index=0&id=38303080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38303080",
  null
  
)

export default component.exports